import { mapGetters } from 'vuex'
import expenseAccount from "@/services/expenseAccount";
import moment from 'moment';
import Utils from "@/mixins/Utils";

export default {
  mixins: [Utils],
  computed: {
    ...mapGetters({
      expenseTypes: "expenseTypes",
      getExpenseSelected: "getExpenseSelected",
    }),
    renderAmoutHT() {
      const amout = (parseFloat(this.currentExpenseToEdit.amountTTC) * 100
        / (100 + parseFloat(this.currentExpenseToEdit.tauxTva))).toFixed(2)
      if (!this.currentExpenseToEdit.tauxTva) {
        return this.currentExpenseToEdit.amountTTC || 0
      } else if (amout === 'NaN') return 0
      return amout
    },
    renderTVA() {
      if (!this.currentExpenseToEdit.tauxTva) {
        return 0
      }
      return (parseFloat(this.currentExpenseToEdit.tauxTva) * this.renderAmoutHT / 100).toFixed(2)
    },
    checkNumber() {
      return (key, value, required = true) => {
        if (!!value) {
          if (key === 'ttc' && Number(value) <= 0) {
            this.errorMessageTTC = this.objectMessage[key].lessThanOne
            return false
          } else if (key === 'tax' && Number(value) < 0) {
            this.errorMessageTax = this.objectMessage[key].lessThanOne
            return false
          } else if (key === 'ttc' && Number(value) >= 10000) {
            this.errorMessageTTC = this.objectMessage[key].moreThen
            return false
          } else if (key === 'tax' && Number(value) > 100) {
            this.errorMessageTax = this.objectMessage[key].moreThen
            return false
          }
          const re = /^[+-]?(\d)+(\.\d+)?$/i
          const rexENumber = /\d+e\d/g
          return re.test(Number(value)) && !rexENumber.test(value)
        } else {
          if (!required) return true
          return null
        }
      }
    }
  },
  async created() {
    try {
      if (this.expenseTypes.length) {
        this.options = this.expenseTypes
      } else {
        const { data } = await expenseAccount.getListTypeExpense()
        this.options = data.map((type) => ({ value: type.Pk, text: type.Name }))
        this.$store.commit('SET_EXPENSE_TYPES', this.options)
      }
      if (this.$route.params.type === 'edit') {
        const queryId = Number(this.$route.query.id)
        if (queryId) {
          if (this.getExpenseSelected && queryId === this.getExpenseSelected.pkNoteDeFrais) {
            this.currentExpenseToEdit = this.getExpenseSelected
          } else {
            const { data } = await expenseAccount.getListExpense()
            this.currentExpenseToEdit = data.find((item) => {
              return item.pkNoteDeFrais === Number(this.$route.query.id)
            })
          }
        } else {
          this.currentExpenseToEdit = this.getExpenseSelected
        }
        if (!this.currentExpenseToEdit) {
          this.$router.push({ name: '404ErrorPageNotFound' })
        }
        this.$set(this.currentExpenseToEdit, 'tauxTva', (this.replaceAmount(this.currentExpenseToEdit.amountTVA) * 100
          / (this.replaceAmount(this.currentExpenseToEdit.amountHT))).toFixed(2))
        this.currentExpenseToEdit.dateNoteDeFrais = this.moment(this.currentExpenseToEdit.dateNoteDeFrais).format("YYYY-MM-DD")
        this.currentExpenseToEdit.amountTTC = this.replaceAmount(this.currentExpenseToEdit.amountTTC)

        // return

        // this.currentExpenseToEdit.amountHT = (parseFloat(this.currentExpenseToEdit.amountTTC) * 100
        //   / (100 + parseFloat(this.currentExpenseToEdit.tauxTva))).toFixed(2)
        // this.currentExpenseToEdit.amountTVA = (parseFloat(this.currentExpenseToEdit.tauxTva) * this.currentExpenseToEdit.amountHT / 100).toFixed(2)
        // this.currentExpenseToEdit.amountTTC = parseFloat(this.currentExpenseToEdit.amountTTC)
      } else {
        this.currentExpenseToEdit = {
          "provider": null,
          "typeFrais": null,
          "amountTTC": null,
          "tauxTva": null,
          "amountHT": 0,
          "dateCreation": (new Date()).valueOf(),
          "pkStatus": 1
        }
      }
    } catch (error) {
    } finally {
      this.isLoading = false
    }
  },
  data() {
    return {
      options: [],
      text: null,
      currentExpenseToEdit: null,
      isLoading: true,
      moment,
      objectMessage: {
        ttc: {
          moreThen: 'Les champs fiscaux doivent être inférieurs à 10000',
          lessThanOne: 'La valeur ne peut être inférieure à 1',
        },
        tax: {
          moreThen: 'La valeur ne peut pas dépasser 100',
          lessThanOne: 'La valeur ne peut être inférieure à 0',
        },
        valueInvalid: `$t('expense-date-invalid')`
      },
      errorMessageTTC: '',
      errorMessageTax: '',
      errorMessageType: '',
      isSubmit: false
    }
  },
  methods: {
    replaceAmount(value) {
      const re = /^[+-]?(\d)+(\,\d+)?$/i
      if (re.test(value)) {
        value = value.replace(',', '.')
      }
      return parseFloat(value)
    },
    checkType(value) {
      if (this.isSubmit && !!value) {
        return false
      } else if (!value) return null
      return true
    },
    checkExpense() {
      let isError = false
      if ( !this.checkNumber('ttc', this.currentExpenseToEdit.amountTTC)
        || !this.checkNumber('tax', this.currentExpenseToEdit.tauxTva, false)
        || !this.currentExpenseToEdit.pkStatus
        || !this.currentExpenseToEdit.dateCreation
        || !this.currentExpenseToEdit.typeFrais) {
        this.callToaster(this.$t('leave-request-enter-all-fields'));
        isError = true
      }
      return isError
    },
    updateNewData() {
      const date = (new Date(this.currentExpenseToEdit.dateNoteDeFrais)).valueOf()
      this.currentExpenseToEdit.dateNoteDeFrais = date
      this.currentExpenseToEdit.amountHT = this.renderAmoutHT
      this.currentExpenseToEdit.amountTVA = this.renderTVA
    },
    async createOrUpdateExpense() {
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          if (this.checkExpense()) return
          this.isLoading = true
          this.isSubmit = true
          try {
            this.updateNewData()
            if (this.$route.params.type === 'edit') {
              const res = await expenseAccount.updateExpense(this.currentExpenseToEdit)
              if (res.success) {
                const { pkNoteDeFrais } = res.data
                this.$store.commit('EXPENSE_SELECTED', { ...this.currentExpenseToEdit, pkNoteDeFrais })
                this.callToaster(this.$t('expense-updated-successful'));
                this.$router.push({
                  name: 'employee-list',
                  params: { id: pkNoteDeFrais }
                })
              }
            } else {
              const res = await expenseAccount.createNewExpense(this.currentExpenseToEdit)
              if (res.success) {
                this.callToaster(this.$t('expense-created-successful'));
                this.$router.push({
                  name: 'employee-list'
                })
              }
            }
          } catch (error) {
          } finally {
            this.isLoading = false
          }
        }
      });
    },
    onClickCancel() {
      this.$router.push({ name: 'employee-list' })
    },
    async deleteExpense() {
      try {
        const value = await this.$bvModal.msgBoxConfirm('Veuillez confirmer que vous souhaitez le supprimer.', {
          title: this.$t('alert-confirm'),
          size: 'md',
          buttonSize: 'sm',
          okTitle: 'OUI',
          okVariant: 'primary',
          cancelTitle: 'NON',
          cancelVariant: 'primary',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
        if (value) {
          await expenseAccount.deleteExpense(this.$route.query.id)
          this.callToaster(this.$t('expense-deleted-successful'));
          this.$router.push({ name: 'employee-list' })
          // TO DO 
        }
      } catch (error) {

      }
    }
  }
}